import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../api/client';
import { selectActiveBusinessAreaIdsForAPI, setBusinessAreas } from './data/businessAreasSlice';
import { setFolders } from './data/foldersSlice';
import { selectActiveObjectLanguageIdsForAPI } from './data/objectLanguagesSlice';
import { setNews, setNewsCategories } from './data/newsSlice';
import { setObjects } from './data/objectsSlice';
import { setProperties } from './data/propertiesSlice';
import { backupEvaluations } from './evaluationsSlice';
import { setTags } from './data/tagsSlice';
import { setDoctypes } from './data/doctypesSlice';
import { setCampaigns } from './data/campaignsSlice';


const initialState = {
	contentUpdateStatus: null,
};

export const contentUpdate = createAsyncThunk('content/update', async (payload, { getState, dispatch }) => {
	const state = getState();
	const activeObjectLanguageIds = selectActiveObjectLanguageIdsForAPI(state);
	const activeBusinessAreaIds = selectActiveBusinessAreaIdsForAPI(state);

	const params = new URLSearchParams();
	params.append('businessareas', activeBusinessAreaIds);
	params.append('objectlanguages', activeObjectLanguageIds);
	params.append('appId', '');
	params.append('isWeb', 1);

	const response = await client.post(process.env.REACT_APP_API_PATH_CONTENT_UPDATE, params, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }});

	dispatch(setBusinessAreas({ businessAreas: response?.data?.businessAreas }));
	dispatch(setFolders({ folders: response?.data?.folders }));
	dispatch(setNews({ news: response?.data?.news }));
	dispatch(setNewsCategories({ newsCategories: response?.data?.news_categories }));
	dispatch(setObjects({ objects: response?.data?.objects }));
	dispatch(setProperties({ properties: response?.data?.properties }));
	dispatch(setTags({ tags: response?.data?.tags }));
	dispatch(setDoctypes({ doctypes: response?.data?.doctypes }));
	dispatch(setCampaigns({ campaigns: response?.data?.campaigns }));
	dispatch(backupEvaluations());
});

export const contentSlice = createSlice({
	name: 'content',
	initialState,
	reducers: {
		resetContent: (state) => {
			state.contentUpdateStatus = initialState.contentUpdateStatus;
		},
	},
	extraReducers: {
		[contentUpdate.fulfilled]: (state) => {
			state.contentUpdateStatus = 'success';
		},
		[contentUpdate.pending]: (state) => {
			state.contentUpdateStatus = 'pending';
		},
		[contentUpdate.rejected]: (state) => {
			state.contentUpdateStatus = 'error';
		},
	},
});

export default contentSlice.reducer;
export const { resetContent } = contentSlice.actions;

export const selectContentStatus = (state) => state.content.contentUpdateStatus;
